import { useRef, useState } from "react";
import { menus } from "@/data/menus";
import { HeaderPopover } from "@/components/molecules/Popover/HeaderPopover";
import { Header } from "@/components/organisms/Header";
import { NavBar } from "@/components/organisms/NavBar";
import * as S from "./MainTemplate.style";
import { Modal } from "@/components/molecules/Modal";
import { Button } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router-dom";

interface MainTemplateProps {
  pageTitle?: any;
  padding?: boolean;
  navBar?: boolean;
  floatButton?: React.ReactNode;
  headerRight?: React.ReactNode;
  children?: React.ReactNode;
  gap?: number;
  onBackHandler?: () => void;
}

export const MainTemplate = ({
  pageTitle,
  padding = true,
  navBar = true,
  floatButton,
  headerRight,
  children,
  gap = 40,
  onBackHandler,
}: MainTemplateProps) => {
  const [popover, setPopover] = useState(false);
  const [learningPwModal, setLearningPwModal] = useState(false);

  const contentRef = useRef<HTMLElement>(null);

  const navigate = useNavigate();

  // const { data: selectedProfile } = useQuery(
  //   [USER_CHILD_PROFILE_SELECTED],
  //   async () => {
  //     const profileId = readProfileId();
  //     const result = await request<ResponseType<MyProfileSelectProps>>({
  //       method: "GET",
  //       url: `profile/selected/${profileId}`,
  //     });

  //     return result.data;
  //   },
  //   {
  //     onError: (error) => {
  //       console.error("Query Error:", error); // 에러 처리 로직
  //       // 추가적인 에러 처리 로직
  //     },
  //   }
  // );

  return (
    <>
      <S.MainTemplate $navBar={navBar}>
        <Header
          setPopover={setPopover}
          // selectedProfile={selectedProfile}
          pageTitle={pageTitle}
          headerRight={headerRight}
          onBackHandler={onBackHandler}
        />
        <S.MainContentBox
          ref={contentRef}
          $navBar={navBar}
          $padding={padding}
          $floatButton={floatButton ? true : false}
          $gap={gap && gap}
        >
          {children}
          {floatButton && floatButton}
        </S.MainContentBox>
        {navBar && (
          <NavBar menu={menus} setLearningPwModal={setLearningPwModal} />
        )}
      </S.MainTemplate>
      {popover === true && <HeaderPopover setPopover={setPopover} />}
      {learningPwModal && (
        <Modal
          title="보호자 비밀번호 설정"
          size="sm"
          onClose={() => setLearningPwModal(false)}
          modalButton={
            <Button
              type="button"
              label="암호 설정하기"
              size="md"
              color="primary100"
              layout="solid"
              onClick={() =>
                navigate(`/mypage/setting?openAppPassword=${learningPwModal}`)
              }
            />
          }
        >
          <>
            <p style={{ color: "black", fontSize: "1.4rem" }}>
              정책상 보호자 설정을 위해 비밀번호가 필요합니다.
            </p>
            <p style={{ color: "black", fontSize: "1.4rem" }}>
              비밀번호 생성 후 이용해주세요.
            </p>
            <br />
            <p>(마이페이지 → 앱 설정 → 보호자 비밀번호 재설정)</p>
          </>
        </Modal>
      )}
    </>
  );
};
